<template>
  <div
    class="modal-card"
    style="width: 100%"   
    data-test-id="shopsDetailsModal"
  >
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t("RelevantShops", { callerEntityDetails: titleString }) }}</p>
      <b-button icon-pack="fas" icon-left="times" @click.stop.prevent="onClose" />
    </header>
    <section class="modal-card-body">
      <shopAdministrationDetails
        :shopsList="shopsList"
        :loading="loading"
        :showRelatedItems="false"
        @member-count-clicked="onMemberCountClicked"
        @notification-group-count-clicked="onNotificationGroupCountClicked"
      />
    </section>
    <footer class="modal-card-foot">
      <b-button @click.stop.prevent="onClose">{{ $t("Close") }}</b-button>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { type Shop } from '@/stores/app'
import shopAdministrationDetails from '@/components/shopAdministrationDetails.vue'

interface Props {
  shopsList: Shop[]
  loading: boolean
  titleString: string
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
})

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'member-count-clicked', shopId: number): void
  (e: 'notification-group-count-clicked', shopId: number): void
}>()

function onMemberCountClicked(shopId: number) {
  emit('member-count-clicked', shopId)
}

function onNotificationGroupCountClicked(shopId: number) {
  emit('notification-group-count-clicked', shopId)
}

function onClose() {
  emit('close')
}
</script>
